// コメントスレッド全体を削除する操作の共通ヘルパー。
// ピンの右クリック（comment-pin）とポップオーバーのゴミ箱ボタン（comment-thread-popover）の双方が、
// 同じ確認ダイアログ文言・選択肢を使うために集約する（文言や挙動が片側だけずれるのを防ぐ）。

import { useShowConfirmDialog } from "@meiden-connect/ui";

type ShowConfirmDialog = ReturnType<typeof useShowConfirmDialog>;

/**
 * スレッド削除前の確認ダイアログを表示し、「削除する」を選んだ場合のみ true を返す。
 * 権限判定（管理者 / 全メッセージが自分の投稿）は domain の canDeleteCommentThread を呼び出し側で行い、
 * 許可されている場合にのみこのダイアログを表示する。最終判定は常にサーバが行う。
 */
export async function confirmDeleteCommentThread(
  showConfirmDialog: ShowConfirmDialog
): Promise<boolean> {
  const answer = await showConfirmDialog(
    "warning",
    "このコメントスレッドを削除しますか？",
    [
      { content: "削除する", value: "delete" },
      { content: "キャンセル", value: "cancel" },
    ],
    { ariaLabel: "コメントスレッド削除の確認" }
  );
  return answer === "delete";
}
